// @flow

import Immutable from 'immutable';

export const APP_LISTING_HOME_LINK = Immutable.Record<{ href: string }>({ href: '/' })();
